// 封装请求方法
import requset from '@/utils/request.js'
// 供需入驻列表（需求方 / 服务商展示卡，接口路径仍是 /ow/companyList）
export const getListingList = (data) =>　{
    return requset({
        url:'/xwzx/ow/companyList',
        method:'GET',
        params:data
    })
}
export const getCompanyList = getListingList
// 企业库（官网只返回已发布）
export const getEnterpriseList = (data) => {
    return requset({
        url: '/xwzx/enterprise/info/list',
        method: 'GET',
        params: data
    })
}
// 新增企业信息
export const enterpriseInfo = (data) =>　{
    return requset({
        url:'/xwzx/enterprise/info',
        method:'POST',
        data
    })
}
// 详情
export const enterpriseInfoDetail = (data) => {
    return requset({
        url:`/xwzx/enterprise/info/${data}`,
        method:'GET'
    })
}
// 新增供需入驻
export const saveListing = (data) =>　{
    return requset({
        url:'/xwzx/company/info',
        method:'POST',
        data
    })
}
export const companyInfo = saveListing
// 供需入驻详情
export const getListingDetail = (data) =>　{
    return requset({
        url:`/xwzx/company/info/${data}`,
        method:'GET'
    })
}
export const companyInfoDetail = getListingDetail
// 数据交易场所列表
export const dataTradingList = (data) =>　{
    return requset({
        url:'/xwzx/dataTrading/info/list',
        method:'GET',
        params:data
    })
}
// 新增数据交易所
export const dataTradingInfo = (data) =>　{
    return requset({
        url:'/xwzx/dataTrading/info',
        method:'POST',
        data
    })
}
// 数据交易详情
export const dataTradingDetail = (data) =>　{
    return requset({
        url:`/xwzx/dataTrading/info/${data}`,
        method:'GET'
    })
}
